import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgSwitch, NgSwitchCase, NgIf } from '@angular/common';

@Component({
    selector: 'alert-content',
    templateUrl: './alert-content.component.html',
    styleUrls: ['./alert-content.component.scss'],
    standalone: true,
    imports: [
        NgSwitch,
        NgSwitchCase,
        NgIf,
    ],
})
export class AlertContentComponent implements OnChanges {
  public openAlert: boolean;
  public mobileStyle: boolean;
  public icon: string;
  public myTitle: string;

  @Input()
  showAlert: any;

  @Input()
  set mobile(status: any) {
    this.mobileStyle = !!status;
  }

  @Input()
  set title(title_name: string) {
    this.myTitle = title_name;
  }

  @Input()
  set imageName(name: any) {
    this.icon = `/hotels/dist/es-AR/browser/assets/images/${name}`;
  }

  @Output()
  emitterHide: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showAlert) {
      this.showPaymentsMethodsAlertMobile(changes.showAlert.currentValue.value);
    } else {
      this.showPaymentsMethodsAlert();
    }
  }

  public show() {
    this.openAlert = true;
  }

  public hide() {
    this.openAlert = false;
  }

  private showPaymentsMethodsAlert() {
    setTimeout(() => {
      this.emitterHide.emit(false);
    }, 5000);
  }

  private showPaymentsMethodsAlertMobile(status: boolean) {
    if (status) {
      this.show();
      setTimeout(() => {
        this.hide();
      }, 5000);
    }
  }
}
